import React from 'react';
import Loader from '@mui/material/Skeleton';
const bgcolor = '#ebebeb';
const Skeleton = (props) => (React.createElement(Loader, Object.assign({ "aria-label": "skeleton-loader" }, props, { sx: { bgcolor }, animation: "wave" })));
export default Skeleton;
//# sourceMappingURL=index.js.map